export default __webpack_public_path__ + "static/media/business-advisory-2.c9a4f158.svg";